import { FC, useRef } from "react";
import { useParams } from "react-router-dom";
import { TabsProvider } from "../../../context/tabsContext";
import { useI18n } from "../../../hooks/useTranslations";
import { useDkvTollImportsApi } from "../../../http/highwayTollCostImports/api";
import Header from "../../ui/Header";
import Tabs, { TabContent, TabsContents } from "../../ui/Tabs";
import DkvTollsImportLines from "./DkvTollsCostImport";

const TabsDkvTolls: FC = () => {
  const i18n = useI18n();

  return (
    <>
      <Header title={i18n.t.common.importHighwayToll} />
      <TabsProvider>
        <TabbedDkvTolls />
      </TabsProvider>
    </>
  );
};

export default TabsDkvTolls;

const TabbedDkvTolls: FC = () => {
  const i18n = useI18n();
  const { id } = useParams<{ id: string }>();
  const aborter = useRef(new AbortController());
  const dkvTollsImportApi = useDkvTollImportsApi();

  const dataWithErrors = dkvTollsImportApi.useDkvTollsImport({}, aborter.current.signal, id!, true);
  const hasError = !!dataWithErrors.data?.total;

  const tabs = [
    { title: i18n.t.common.all },
    { title: i18n.t.common.withErrors, hasError },
    { title: i18n.t.common.withoutErrors },
    { title: i18n.t.common.itemsNotExported },
    { title: i18n.t.common.itemsForced },
  ];

  const tabComponents: TabContent[] = [
    { body: <DkvTollsImportLines />, withBorder: true },
    { body: <DkvTollsImportLines withErrors />, withBorder: true },
    { body: <DkvTollsImportLines withErrors={false} />, withBorder: true },
    { body: <DkvTollsImportLines notExported />, withBorder: true },
    { body: <DkvTollsImportLines forced />, withBorder: true },
  ];

  return (
    <>
      <Tabs tabs={tabs} />
      <TabsContents contents={tabComponents} />
    </>
  );
};
